import React from "react";
import "./Footer.css";
import linkedin from "../../assets/linkedin.png";
import instagram from "../../assets/instagram.png";
import github from "../../assets/github.png";
import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <div className="footerContainer">
      <hr />
      <div className="footer">
        <div className="blur blur-F-1"></div>
        <div className="blur blur-F-2"></div>

        <div className="social-links">
          <img src={linkedin} alt="" />
          <img src={instagram} alt="" />
          <img src={github} alt="" />
        </div>
        <div className="logo-f">
          <img src={logo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
